import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(default-background)/calendar/Calendar.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/(default-background)/calendar/CalendarEvents/CalendarEvents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/(default-background)/calendar/CalendarSelect/CalendarSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/(default-background)/calendar/EventsSlider/EventsSlider.tsx");
